export default "__VITE_ASSET__Du5goC8r__"